// "⇄ Likely transfer?" pending review row, drawn identically at every band
// in `#s06` and matching the shared `likely-transfer-review` honest-state
// wording (RouteStates.tsx). Confirm posts the pairing; the unavailable reject
// action remains visibly disabled and explains the retained activity honestly.
import { AmountText } from '@/components/AmountText';
import { Button } from '@moneyskyline/ui';
import type { InboxTransferReviewItem } from '@/api/hooks/useInboxItems';

export function TransferReviewCard({
  item,
  onConfirm,
  pending,
}: {
  item: InboxTransferReviewItem;
  onConfirm: (groupId: string) => void;
  pending?: boolean;
}) {
  return (
    <div
      className="rounded-lg border border-border border-l-4 border-l-money-neutral bg-card p-3"
      data-testid="transfer-review-card"
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="text-sm">
          <span className="font-semibold text-money-neutral">⇄ Likely transfer?</span>{' '}
          <span className="text-foreground">
            Checking •{item.leg_a.account_last4} <AmountText value={item.leg_a.amount} variant="transfer" /> {item.leg_a.posted_at} ·
            Brokerage •{item.leg_b.account_last4} <AmountText value={item.leg_b.amount} variant="transfer" /> {item.leg_b.posted_at}
          </span>
        </div>
        <div className="flex gap-2">
          <Button type="button" size="sm" disabled={pending} onClick={() => onConfirm(item.group_id)}>
            Confirm
          </Button>
          <Button
            type="button"
            size="sm"
            variant="outline"
            disabled
            aria-label="Not a transfer"
          >
            Not a transfer
          </Button>
        </div>
      </div>
      <p className="mt-2 text-xs text-muted-foreground">
        Not a transfer is not available yet. Until you confirm, both transactions continue to count as ordinary activity.
      </p>
    </div>
  );
}

export default TransferReviewCard;
